import React, { useMemo, useState } from 'react'
import EcoSystem from '~/assets/images/home/eco-system-2.png'

import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'

import { Field } from '~/components/Formik'
import LanguageSwitcher from '~/components/LanguageSwitcher'
import useGuestContact from '~/modules/shared/redux/hooks/useGuestContact'
import { useClasses } from '~/themes'
// import logoIcon from '~/assets/images/MESX.svg'
import logoIcon from '~/assets/images/vti-solution.svg'

import {
  CURRENT_ROLE_OPTIONS,
  EXPERIMENTAL_PURPOSE,
  INTEREST_FEATURE_OPTIONS,
  VIETNAM_PROVINCES,
  WORK_TYPE_OPTIONS,
} from './dummy-data'
import { contactSchema } from './schema'
import style from './style'
import Checkbox from '~/components/Checkbox'
import Icon from '~/components/Icon'
import { redirectRouter } from '~/utils'

const ContactPage = () => {
  const classes = useClasses(style)
  const { t } = useTranslation('mkt')

  const largeScreenWidth = useMediaQuery('(min-width:720px)')

  const defaultTextFieldLabelStyles = {
    fontSize: '14px !important',
    color: '#272e4e !important',
    lineHeight: '22px !important',
    fontWeight: '400 !important',
  }

  const {
    data: { isLoading },
    actions,
  } = useGuestContact()

  const [step, setStep] = useState(1)
  const [isSubcribe, setIsSubcribe] = useState(false)
  const [message, setMessage] = useState('')

  const initialValues = useMemo(
    () => ({
      fullName: '',
      phoneNumber: '',
      workEmail: '',
      otp: '',
      enterpriseName: '',
      area: '',
      currentRole: '',
      workType: '',
      interestFeature: '',
      experientalPurpose: '',
    }),
    [],
  )

  const onSubmit = (values, { resetForm }) => {
    const convertValues = {
      step: step,
      isSubscribe: parseInt(isSubcribe),
      email: values?.workEmail,
      fullname: values?.fullName,
      otp: values?.otp,
      phone: values?.phoneNumber,
      companyName: values?.enterpriseName,
      addressZone: values?.area,
      bussinessType: values?.workType,
      features: values?.interestFeature,
      purpose: values?.experientalPurpose,
      role: values?.currentRole,
    }

    if (step == 1) {
      actions.createGuestContact(convertValues, (data) => {
        if (data.isValidEmail) {
          setStep(2)
        } else {
          redirectRouter('/contact-us')
        }
      })
    } else {
      actions.createGuestContact(convertValues, (data) => {
        setMessage(data.message)
        resetForm(initialValues)
        if(fbq) {
          fbq('track', 'CompleteRegistration');
        } else {
          window.fbq('track', 'CompleteRegistration');
        }
        setTimeout(function () {
          if (data?.url) {
            window.location.replace(data?.url)
          }else {
          redirectRouter('/contact-us')
          }
      }, 3000);
      })
    }
  }

  return (
    <Box className={classes.root} loading={isLoading}>
      <Box
        className={classes.floatMenu}
        sx={
          largeScreenWidth
            ? {
                display: 'flex',
                // justifyContent: 'right',
                position: 'absolute',
                bottom: '0.5rem',
                top: '0.5rem',
              }
            : { display: 'flex', justifyContent: 'right' }
        }
      >
        <Box
          sx={{
            minWidth: 80,
            height: 40,
            pl: 1.5,
            pr: 1,
            textTransform: 'uppercase',
            justifyContent: 'flex-start',
          }}
        >
          <img src={logoIcon} alt="" />
        </Box>
      </Box>
      <Box
        className={classes.floatBtn}
        sx={
          largeScreenWidth
            ? {
                display: 'flex',
                // justifyContent: 'right',
                position: 'absolute',
                bottom: '0.5rem',
                right: '0.5rem',
              }
            : { display: 'flex', justifyContent: 'right' }
        }
      >
        <LanguageSwitcher />
      </Box>
      <Grid container justifyContent="center" className={classes.gridContainer}>
        <Grid container justifyContent="center" lg={10} md={10} xs={12}>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            enableReinitialize
            validationSchema={contactSchema(t, step)}
          >
            {({ values, handleReset, setFieldValue }) => {
              return step === 2 ? (
                <Grid
                  container
                  className={classes.optPage}
                  justifyContent="space-around"
                  alignItems="center"
                >
                  <Grid md={6} xs={12}>
                    <Paper className={classes.paperWrap}>
                      <Typography
                        fontSize={14}
                        variant="subtitle"
                        fontWeight={700}
                        color={'#0050AE'}
                      >
                        {t('contact.otpPageTitle')}
                      </Typography>
                      <Typography
                        fontSize={14}
                        marginTop={'10px'}
                        marginBottom={'20px'}
                        variant="subtitle"
                        color={'#0050AE'}
                      >
                        {t('contact.otpPageDesc')}
                      </Typography>
                      {/* <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                    enableReinitialize
                    validationSchema={() => {
                      return Yup.object().shape({
                        otp:
                          step == 1
                            ? Yup.string().optional()
                            : Yup.string().required(t('form.required')),
                      })
                    }}
                  > */}
                      <Form>
                        <Grid item lg={12} xs={12}>
                          <Field.TextField
                            name="otp"
                            label={t('contact.otp')}
                            required
                            vertical
                            borderRadius={20}
                            sx={{ mb: 2 }}
                            placeholder={t('contact.inputOtp')}
                            labelSx={defaultTextFieldLabelStyles}
                          />
                        </Grid>
                        <Grid item lg={12} xs={12}>
                          <Button
                            type="submit"
                            icon="save"
                            sx={{ width: '100%', borderRadius: 20 }}
                          >
                            {t('contact.submit')}
                          </Button>
                        </Grid>
                      </Form>
                      {/* </Formik> */}
                    </Paper>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Box className={classes.ecoSystem}>
                      <img src={EcoSystem} alt=""></img>
                    </Box>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid container style={{justifyContent: 'center', flexDirection: 'column'}} md={5} xs={12}>
                    {/* <Grid item xs={11}> */}
                    <Box className={classes.intro}>
                      <h2 style={{ margin: 0,  }}>{t('contact.title')}</h2>
                      <Typography fontSize={12}>
                        {t('contact.description')}
                      </Typography>
                      <Box
                        sx={{
                          marginTop: 2,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {/* <Icon
                     color="#0050AE"
                     name="phone"
                     size={30}
                     sx={{ marginRight: 1 }}
                   /> */}
                        {'  '}
                        <Typography
                          fontSize={22}
                          variant="subtitle"
                          fontWeight={700}
                          color={'#0050AE'}
                        >
                          {t(`contact.hightlightFeatures`)}
                        </Typography>
                      </Box>{' '}
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* <Icon
                     color="#0050AE"
                     name="amail"
                     size={15}
                     sx={{ marginRight: 1 }}
                   /> */}
                        {'  '}
                        <Typography
                          fontSize={14}
                          fontWeight={600}
                          variant="subtitle"
                          color={'#0050AE'}
                        >
                          {t(`contact.beComfort`)}
                        </Typography>
                      </Box>{' '}
                      <ul className={classes.featureList}>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={14}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              MESCore:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.MESCore`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={14}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              WMS-X:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.WMSx`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={14}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              QMS-X:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.QMSx`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={14}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              MMS-X:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.MMSx`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={15}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              TMS-X:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.TMSx`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                        <li>
                          <Box
                            sx={{
                              marginTop: 2,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Icon
                              color="#0050AE"
                              name="checkCircle"
                              size={14}
                              sx={{ marginRight: 1 }}
                            />
                            {'  '}
                            <Typography
                              fontSize={14}
                              variant="subtitle"
                              fontWeight={600}
                              sx={{ marginRight: 1 }}
                            >
                              PMS-X:
                            </Typography>{' '}
                            <Typography fontSize={14} variant="subtitle">
                              {t(`contact.PMSx`)}
                            </Typography>
                          </Box>{' '}
                        </li>
                      </ul>
                    </Box>
                    {/* </Grid> */}
                    <Grid item lg={6} md={8} xs={12}>
                      <Box className={classes.ecoSystem}>
                        {/* <img src={EcoSystem} alt=""></img> */}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container md={7} xs={12}>
                    <Grid item xl={6} xs={12}>
                      <Paper className={classes.paperWrap}>
                        <Form>
                          <Grid
                            container
                            rowSpacing={0.5}
                            columnSpacing={{ xl: 6, xs: 4 }}
                          >
                            <Grid item md={6} xs={12}>
                              <Field.TextField
                                name="fullName"
                                label={t('contact.fullName')}
                                required
                                fontSize={14}
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.TextField
                                name="phoneNumber"
                                label={t('contact.phoneNumber')}
                                required
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.TextField
                                name="workEmail"
                                label={t('contact.workEmail')}
                                required
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.TextField
                                name="enterpriseName"
                                label={t('contact.enterpriseName')}
                                required
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.Autocomplete
                                name="area"
                                label={t('contact.area')}
                                options={VIETNAM_PROVINCES}
                                getOptionLabel={(opt) => (opt ? opt : '')}
                                getOptionValue={(opt) => opt}
                                required
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                                freeSolo
                                onInputChange={(event, value) => {
                                  setFieldValue('area', value)
                                }}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.Autocomplete
                                name="currentRole"
                                label={t('contact.currentRole')}
                                options={CURRENT_ROLE_OPTIONS}
                                required
                                getOptionLabel={(opt) =>
                                  opt ? t(opt?.key) : ''
                                }
                                getOptionValue={(opt) => (opt ? opt.key : null)}
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                                // multiple
                                freeSolo
                                onInputChange={(event, value) => {
                                  setFieldValue('currentRole', [value])
                                }}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.Autocomplete
                                name="workType"
                                label={t('contact.workType')}
                                options={WORK_TYPE_OPTIONS}
                                required
                                getOptionLabel={(opt) =>
                                  opt ? t(opt?.key) : ''
                                }
                                getOptionValue={(opt) => (opt ? opt.key : null)}
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                                freeSolo
                                // multiple
                                onInputChange={(event, value) => {
                                  setFieldValue('workType', [value])
                                }}
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Field.Autocomplete
                                name="interestFeature"
                                label={t('contact.interestFeature')}
                                required
                                options={INTEREST_FEATURE_OPTIONS}
                                getOptionLabel={(opt) =>
                                  opt ? t(opt?.key) : ''
                                }
                                getOptionValue={(opt) => (opt ? opt.key : null)}
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                                freeSolo
                                // multiple
                                onInputChange={(event, value) => {
                                  setFieldValue('interestFeature', [value])
                                }}
                              />
                            </Grid>
                            <Grid item lg={12} xs={12}>
                              <Field.Autocomplete
                                name="experientalPurpose"
                                label={t('contact.experientalPurpose')}
                                required
                                options={EXPERIMENTAL_PURPOSE}
                                getOptionLabel={(opt) =>
                                  opt ? t(opt?.key) : ''
                                }
                                getOptionValue={(opt) => (opt ? opt.key : null)}
                                vertical
                                borderRadius={20}
                                sx={{ mb: 2 }}
                                labelSx={defaultTextFieldLabelStyles}
                                freeSolo
                                // multiple
                                onInputChange={(event, value) => {
                                  setFieldValue('experientalPurpose', [value])
                                }}
                              />
                            </Grid>
                            <Grid item lg={12} xs={12}>
                              <FormControlLabel
                                className={classes.checkbox}
                                name="subscribe"
                                control={
                                  <Checkbox
                                    className={classes.checkboxBtn}
                                    checked={isSubcribe}
                                    onChange={(e) =>
                                      setIsSubcribe(e.target.checked)
                                    }
                                    name="subscribe"
                                  />
                                }
                                label={t('contact.subscribe')}
                              />
                              <Typography className={classes.policy}>
                                {t('contact.policy')}
                                <a href="https://vti-solutions.vn/privacy/">
                                  {t('contact.policyLink')}
                                </a>
                                {t('contact.ofUs')}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} xs={12}>
                              <Button
                                type="submit"
                                icon="save"
                                sx={{ width: '100%', borderRadius: 20 }}
                                className={classes.getOTPBtn}
                              >
                                {t('contact.getOtp')}
                              </Button>
                            </Grid>
                          </Grid>
                        </Form>
                      </Paper>
                    </Grid>
                  </Grid>
                </>
              )
            }}
          </Formik>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactPage
